var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustoryThumbnail12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 197,
    viewBox: "0 0 442 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079_4873)",
    filter: "url(#filter0_d_1079_4873)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434,
    height: 189,
    transform: "translate(4 4)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.903 72.874H284.07V159.804H284.903V72.874Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.418 62.1602H284.481V64.4197H293.418V62.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.641 66.3447H284.481V68.6043H291.641V66.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.276 164.945H284.892V167.962H294.276V164.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.786 28.7871C318.786 28.7871 340.86 54.9208 326.853 71.8426C312.857 88.7643 309.004 72.1778 309.004 72.1778C309.004 72.1778 300.627 73.7296 315.132 52.562C321.98 42.5802 318.786 28.7871 318.786 28.7871Z",
    fill: "url(#paint0_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.161 8.38867C367.161 8.38867 383.555 32.5608 355.018 60.3954C326.48 88.2424 328.593 104.841 328.593 104.841C328.593 104.841 299.41 47.7817 367.161 8.38867Z",
    fill: "url(#paint1_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.261 94.3523C311.292 95.4324 325.176 63.0911 343.894 54.6489C362.6 46.2066 378.435 46.9267 389.372 38.0127C389.372 38.0003 382.238 89.0262 323.261 94.3523Z",
    fill: "url(#paint2_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.833 72H154V158.93H154.833V72Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.451 72.874H260.618V159.804H261.451V72.874Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.439 72.874H319.606V159.804H320.439V72.874Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.132 62.1602H170V64.4197H184.132V62.1602Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.036 66.3447H170V68.6043H190.036V66.3447Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.988 62.1602H260.407V64.4197H276.988V62.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.009 66.3447H260.407V68.6043H271.009V66.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.707 62.1602H320.428V64.4197H330.707V62.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.409 66.3447H320.428V68.6043H332.409V66.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.368 62.1602H379.403V64.4197H394.368V62.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.385 66.3447H379.403V68.6043H391.385V66.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.424 164.945H261.04V167.962H270.424V164.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.812 164.945H320.428V167.962H329.812V164.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.201 153.681C172.239 153.681 152.421 136.899 133.037 120.482C118.339 108.039 103.092 95.2979 85.468 89.019C31.7275 69.8624 4.25144 104.842 4 105.162V94.5216C4.29716 94.1563 9.1889 87.786 23.3841 81.7354C36.2992 76.2099 57.9691 71.8032 87.8682 82.192C106.795 88.7678 122.545 102.102 137.746 114.98C168.605 141.1 195.258 163.682 241.524 128.337C276.566 101.554 309.619 76.0501 342.124 66.7344C373.921 57.6242 407.065 64.2913 438.107 95.2751V105.002C372.183 38.8786 315.837 80.7079 245.958 134.09C227.42 148.201 211.465 153.658 197.201 153.681Z",
    fill: "url(#paint3_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.834 68.6289H120V80.8577H122.834V68.6289Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.882 63.6621H127.048V80.857H129.882V63.6621Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.916 61.0684H134.082V80.8456H136.916V61.0684Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 60H141.117V80.8573H143.951V60Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.834 73.1846H120V80.8571H122.834V73.1846Z",
    fill: "url(#paint4_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.882 70.0693H127.048V80.858H129.882V70.0693Z",
    fill: "url(#paint5_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.916 68.4424H134.082V80.8575H136.916V68.4424Z",
    fill: "url(#paint6_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.951 67.7715H141.117V80.857H143.951V67.7715Z",
    fill: "url(#paint7_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.886 176.472H308.856C313.214 176.472 316.742 172.948 316.742 168.595V39.3064C316.742 34.9538 313.214 31.4297 308.856 31.4297H214.886C210.528 31.4297 207 34.9538 207 39.3064V168.582C207 172.935 210.528 176.472 214.886 176.472Z",
    fill: "url(#paint8_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1 47.7842H275.166V51.1859H302.1V47.7842Z",
    fill: "url(#paint9_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.888 62.0488H275.166V65.4506H299.888V62.0488Z",
    fill: "url(#paint10_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.557 54.9219H275.166V58.3236H296.557V54.9219Z",
    fill: "url(#paint11_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 78.1387H225.053V81.168H256.001V78.1387Z",
    fill: "#4E7ED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 86.3076H225.053V89.3369H256.001V86.3076Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.001 94.4648H225.053V97.4941H256.001V94.4648Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.485 78.1387H285.314V81.168H290.485V78.1387Z",
    fill: "#4E7ED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.485 86.3076H262.314V89.3369H267.485V86.3076Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.485 94.4639H262.314V97.4931H267.485V94.4639Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.286 150.149C366.454 150.149 337.035 135.536 306.381 120.306C268.526 101.514 229.391 82.0605 177.249 87.3807C143.944 90.7828 123.05 104.323 104.603 116.287C87.9159 127.11 72.1202 136.632 50.7469 137.431C16.1839 138.755 4.20573 124.028 4 123.137V113.684C4.04572 113.844 11.5892 130.375 50.7012 130.17C69.9715 130.079 84.1899 120.854 100.648 110.191C119.782 97.7926 141.452 83.7502 176.518 80.1654C230.763 74.6398 270.858 94.5503 309.627 113.799C350.202 133.96 388.925 152.843 438.095 136.381V144.144C423.899 148.893 412.744 150.149 400.286 150.149Z",
    fill: "url(#paint12_radial_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.551 168.879H300.285C295.151 168.879 291 164.72 291 159.605V84.3698C291 79.2423 295.164 75.0957 300.285 75.0957H343.551C348.684 75.0957 352.835 79.2548 352.835 84.3698V159.605C352.835 164.72 348.684 168.879 343.551 168.879Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.47 89.0404C344.953 84.8069 340.901 82.2121 336.638 82.3363C335.606 82.3611 334.562 82.5598 333.531 82.9198C330.424 84.0247 328.186 86.5078 327.279 89.4253C326.645 91.449 326.645 93.6961 327.416 95.8439C327.49 96.0549 327.577 96.266 327.664 96.4771C328.074 97.4082 328.596 98.2524 329.23 98.9973C331.878 102.113 336.278 103.417 340.354 101.965C345.612 100.077 348.346 94.292 346.47 89.0404ZM339.484 99.5808C336.427 100.673 333.133 99.6926 331.144 97.3585C330.672 96.7998 330.274 96.1667 329.964 95.4714C329.901 95.3225 329.839 95.1611 329.777 94.9997C329.205 93.3857 329.205 91.7097 329.678 90.1826C330.361 87.9851 332.039 86.1353 334.364 85.3035C335.134 85.0304 335.917 84.8814 336.688 84.8566C339.882 84.7572 342.927 86.7064 344.058 89.8847C345.488 93.8326 343.437 98.1655 339.484 99.5808Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.69 90.1823L327.267 89.4249C328.186 86.5074 330.411 84.0244 333.518 82.9194C334.55 82.547 335.594 82.3608 336.626 82.3359L336.7 84.8686C335.93 84.8934 335.147 85.03 334.376 85.3156C332.052 86.1349 330.374 87.9848 329.69 90.1823Z",
    fill: "#537FFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.976 95.4709L327.652 96.4766C327.565 96.2655 327.478 96.0545 327.403 95.8434C326.632 93.6956 326.632 91.4485 327.266 89.4248L329.69 90.1821C329.218 91.6968 329.205 93.3852 329.789 94.9992C329.839 95.1482 329.914 95.3095 329.976 95.4709Z",
    fill: "#4BA6F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.218 98.9976C328.585 98.2527 328.05 97.4084 327.652 96.4773L329.977 95.4717C330.275 96.1669 330.685 96.8001 331.157 97.3588L329.218 98.9976Z",
    fill: "#46BBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.849 147.7H331.393V165.565H336.849V147.7Z",
    fill: "#46BBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.733 152.717H323.276V165.579H328.733V152.717Z",
    fill: "#46BBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.717 139.419H339.261V165.578H344.717V139.419Z",
    fill: "#46BBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.123 145.864L299.65 145.504L308.537 133.946L319.512 134.542L327.79 121.382L336.702 120.463L342.059 109.873L342.593 110.146L337.087 121.022L328.138 121.941L319.823 135.15L308.823 134.554L300.123 145.864Z",
    fill: "#46BBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.937 88.4062H284.426C283.444 88.4062 282.648 87.6116 282.648 86.6308C282.648 85.65 283.444 84.8555 284.426 84.8555H299.937C300.919 84.8555 301.715 85.65 301.715 86.6308C301.702 87.6116 300.907 88.4062 299.937 88.4062Z",
    fill: "#4E7ED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.937 94.5761H284.426C283.444 94.5761 282.648 93.7815 282.648 92.8007C282.648 91.82 283.444 91.0254 284.426 91.0254H299.937C300.919 91.0254 301.715 91.82 301.715 92.8007C301.702 93.7939 300.907 94.5761 299.937 94.5761Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.937 100.759H284.426C283.444 100.759 282.648 99.9642 282.648 98.9834C282.648 98.0026 283.444 97.208 284.426 97.208H299.937C300.919 97.208 301.715 98.0026 301.715 98.9834C301.702 99.9766 300.907 100.759 299.937 100.759Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.914 137.929H176.154L174.252 133.969H168L169.914 137.929Z",
    fill: "url(#paint13_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.789 137.929H179.268L177.367 133.969H175.875L177.789 137.929Z",
    fill: "url(#paint14_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.706 11.6683H343.073V9.43359H330.706V11.6683Z",
    fill: "url(#paint15_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.706 8.81274H343.073V8.39062H330.706V8.81274Z",
    fill: "url(#paint16_linear_1079_4873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.135 150.977C376.135 150.977 369.995 149.239 362.487 150.977L366.092 132.541C366.079 132.541 375.078 142.063 376.135 150.977Z",
    fill: "#B3B7C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.567 182.536C359.567 182.536 356.771 187.279 355.59 188.049C353.986 189.104 354.993 190.159 355.751 190.159C356.51 190.159 360.4 190.432 361.258 189.464C362.115 188.496 362.538 185.578 363.333 184.821C364.129 184.064 364.862 181.245 362.948 180.289C360.847 179.259 359.567 182.536 359.567 182.536Z",
    fill: "#2D2D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.623 180.053C360.623 180.053 357.578 186 357.031 186.831C356.485 187.663 358.076 187.651 359.057 187.266C360.039 186.881 362.612 182.933 362.886 182.163C363.159 181.406 362.96 180.301 362.96 180.301L360.623 180.053Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.029 183.442L363.295 189.128L362.897 189.153L363.022 185.056L364.029 183.442Z",
    fill: "#2D2D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.578 177.917C383.578 177.917 382.907 183.379 382.136 184.559C381.08 186.16 382.434 186.731 383.13 186.433C383.826 186.135 387.506 184.832 387.903 183.603C388.301 182.374 387.53 179.531 387.953 178.513C388.376 177.495 387.928 174.627 385.79 174.515C383.441 174.391 383.578 177.917 383.578 177.917Z",
    fill: "#2D2D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.543 175.223C383.543 175.223 383.133 181.889 382.959 182.87C382.785 183.839 384.239 183.205 384.985 182.461C385.73 181.703 386.501 177.072 386.451 176.265C386.402 175.458 385.78 174.527 385.78 174.527L383.543 175.223Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.029 176.961L389.62 182.473L389.272 182.647L387.743 178.848L388.029 176.961Z",
    fill: "#2D2D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.081 127.909C357.081 127.909 356.994 128.94 357.056 130.045C357.094 130.578 356.199 133.769 356.049 134.166C355.925 134.502 355.764 134.228 355.714 133.968C355.689 133.819 355.826 132.664 355.801 132.019C355.788 131.485 355.689 131.249 355.552 131.385C355.416 131.522 354.633 133.496 354.546 134.415C354.459 135.333 353.651 137.27 353.278 136.848C352.905 136.426 352.967 132.478 353.477 131.137C353.986 129.809 355.005 128.257 355.005 128.257L357.081 127.909Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.504 128.679C357.653 128.257 361.32 122.384 362.19 120.51C363.06 118.635 363.831 116.922 364.253 116.189C364.278 116.14 364.328 116.053 364.39 115.941C364.676 115.395 365.297 114.178 365.931 113.048C365.981 112.974 366.018 112.887 366.068 112.812L366.18 112.365C366.615 111.583 366.366 111.062 366.453 110.404C366.478 110.205 366.54 109.994 366.652 109.758C366.652 109.746 366.664 109.746 366.664 109.733C367.199 108.678 367.621 107.747 367.758 107.201C368.193 105.413 370.306 97.4922 370.306 97.4922C370.306 97.4922 366.901 98.6964 366.366 99.9131C365.558 101.763 364.614 104.544 364.353 105.401C364.092 106.257 361.693 113.396 361.196 114.836C360.698 116.289 360.189 117.505 359.642 118.424C359.095 119.355 355.105 127.748 354.819 128.505C354.807 128.517 357.355 129.101 357.504 128.679Z",
    fill: "#DBDFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.884 136.438C371.747 137.109 370.852 139.927 369.858 143.055C368.95 145.911 367.944 149.015 367.347 151.001C367.123 151.746 366.949 152.329 366.862 152.677C366.29 155.024 366.937 158.711 367.148 161.802C367.359 164.881 366.179 180.512 366.179 180.512C365.396 180.872 360.362 180.226 360.362 180.226C360.933 179.134 361.12 159.468 360.797 158.276C360.486 157.072 360.275 153.732 360.585 152.429C360.648 152.156 360.685 151.808 360.685 151.386C360.71 149.735 360.374 147.016 360.163 144.024C359.902 140.262 361.368 130.914 361.58 130.069C361.605 129.995 361.63 129.883 361.667 129.746C362.052 128.43 363.295 124.706 363.295 124.706C365.806 123.961 367.707 123.825 369.124 124.11C371.001 124.495 372.033 125.612 372.542 127.04C373.773 130.442 372.07 135.557 371.884 136.438Z",
    fill: "#3B3B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.463 174.516L382.423 177.781C381.988 175.696 372.728 159.171 372.094 157.545C371.46 155.931 370.789 152.79 370.789 151.635C370.789 151.424 370.777 151.089 370.74 150.63C370.628 148.892 370.305 145.602 369.845 143.044C369.758 142.572 369.671 142.113 369.571 141.703C369.062 139.493 368.975 131.957 368.975 127.525C368.975 125.551 368.987 124.198 368.987 124.198C368.987 124.198 369.037 124.161 369.111 124.099C370.068 123.379 376.184 118.984 378.321 123.093C378.881 124.173 379.254 125.34 379.477 126.557C380.161 130.281 379.49 134.478 378.943 138.302C378.471 141.567 377.563 146.185 377.302 149.624C377.153 151.511 377.215 153.038 377.638 153.783C378.843 155.869 380.012 157.644 382.448 165.019C383.243 167.415 386.463 174.516 386.463 174.516Z",
    fill: "#3B3B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.496 86.1691C367.496 86.1691 366.166 77.5655 373.3 77.7269C380.434 77.8882 380.335 82.1342 380.211 86.3553C380.086 90.5764 377.352 90.2537 380.434 96.126C383.517 101.998 377.762 101.998 377.762 101.998L373.3 95.8777L367.496 86.1691Z",
    fill: "#2D3133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.518 78.5472C372.518 78.5472 367.696 79.3045 367.497 86.1576C367.31 93.0107 368.802 94.4757 373.028 93.048C377.254 91.6203 378.584 84.4443 378.683 83.3394C378.77 82.2345 379.019 77.7278 372.518 78.5472Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.995 102.385C381.02 104.743 378.298 110.38 377.876 112.13C377.453 113.869 376.794 114.427 377.354 116.662C377.913 118.897 379.641 126.433 379.566 127.091C379.491 127.749 369.001 131.076 361.668 129.735C361.668 129.735 364.527 119.095 364.738 117.866C364.949 116.637 364.489 112.081 364.378 110.79C364.278 109.498 362.973 106.73 363.01 105.439C363.06 104.123 363.706 102.981 364.614 101.578C364.9 101.143 365.185 100.696 365.484 100.262C366.441 98.8587 367.398 97.58 367.87 97.1455C368.218 96.8227 368.554 96.5744 368.827 96.3757C369.424 95.9784 369.822 95.8543 369.822 95.8543L373.973 95.1963C373.973 95.1963 376.558 96.1274 378.05 96.475C378.05 96.4875 380.946 96.9096 380.995 102.385Z",
    fill: "#E55353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.826 96.3877L366.414 100.174L364.189 103.663C364.189 103.638 364.339 103.117 364.587 101.577C364.637 101.292 364.687 100.956 364.736 100.596C364.749 100.485 364.774 100.385 364.811 100.274C365.78 98.0886 368.714 96.4374 368.826 96.3877Z",
    fill: "#E55353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.738 89.9692C375.315 90.7637 374.88 95.6553 374.88 95.6553C374.88 95.6553 368.976 97.89 369.585 96.6236C369.859 96.0525 369.946 95.3076 369.946 94.6745C369.946 94.1655 369.908 93.7309 369.883 93.4826C369.871 93.3585 369.859 93.284 369.859 93.284C369.859 93.284 376.16 89.1746 375.738 89.9692Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.542 83.4638C370.542 83.4638 373.015 87.4987 375.278 89.0754C377.527 90.6645 376.384 91.9308 376.384 91.9308C376.384 91.9308 382.263 79.553 376.67 78.6964C371.076 77.8397 367.646 77.7777 367.484 86.1578C367.497 86.1702 370.032 83.4017 370.542 83.4638Z",
    fill: "#2D3133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.238 92.9746C372.331 94.3154 369.932 94.6755 369.932 94.6755C369.932 94.1665 369.895 93.7319 369.87 93.4836C371.411 93.7692 373.238 92.9746 373.238 92.9746Z",
    fill: "#A77860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.849 100.248C364.849 100.248 364.725 100.508 364.613 101.576L365.483 100.26C365.483 100.26 367.037 98.0376 367.571 97.4541C368.106 96.8706 368.839 96.374 368.839 96.374C368.839 96.374 365.769 97.8514 364.849 100.248Z",
    fill: "#DBDFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.937 114.451C377.937 114.451 376.197 115.06 374.569 115.407C372.953 115.755 374.618 117.692 374.618 117.692C374.618 117.692 377.427 117.431 378.782 117.307C379.429 117.245 377.937 114.451 377.937 114.451Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.594 103.564C376.594 103.564 380.385 102.075 381.504 101.988C381.504 101.988 380.746 95.9043 377.017 96.5499C373.301 97.2079 376.594 103.564 376.594 103.564Z",
    fill: "#E55353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.82 95.8664C369.82 95.8664 367.036 100.137 367.981 100.51C368.925 100.882 374.021 100.013 376.184 95.9533C376.184 95.9533 372.94 94.2897 369.82 95.8664Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.892 95.4814C374.892 95.4814 371.947 100.373 371.549 109.672C371.164 118.971 374.47 148.68 374.258 152.293L383.17 148.444C383.17 148.444 379.814 124.16 378.696 119.517C377.577 114.874 381.107 108.79 381.492 101.987C381.492 101.987 381.244 97.3189 378.534 96.5491C375.837 95.7918 374.892 95.4814 374.892 95.4814Z",
    fill: "#DBDFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.846 100.397C380.846 100.397 380.175 95.9029 376.881 96.6478C373.711 97.3554 376.682 103.253 376.918 103.948C377.154 104.643 379.491 110.342 379.702 111.087C380.349 113.445 379.74 113.507 378.77 114.054C375.911 115.692 370.045 115.593 369.361 116.04C368.69 116.487 368.727 117.902 369.858 117.952C371.337 118.014 379.802 117.22 380.983 117.108C382.126 116.996 384.401 116.897 383.804 112.837C383.406 110.093 380.846 100.397 380.846 100.397Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.821 95.8662C369.821 95.8662 366.688 101.068 366.514 107.226C366.34 113.384 360.61 139.642 361.207 153.087L359.865 151.796C359.43 151.374 359.206 150.79 359.243 150.195C359.479 146.333 360.499 131.584 363.022 123.502C365.943 114.154 363.494 107.946 362.997 106.282C362.5 104.619 364.078 102.397 364.6 101.602C365.135 100.795 366.39 97.1325 369.821 95.8662Z",
    fill: "#DBDFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.658 106.978L379.293 123.589L368.629 125.277L365.559 108.74L376.658 106.978Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.185 108.008L378.535 122.757L369.051 124.259L366.329 109.572L376.185 108.008Z",
    fill: "#E0CEC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.301 108.841L373.14 107.798L369.312 108.406L369.324 109.474L373.301 108.841Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.568 115.408C374.568 115.408 372.803 115.706 372.642 115.681C372.48 115.656 371.784 114.514 370.976 114.315C370.168 114.117 369.162 113.955 368.913 113.794C368.664 113.645 368.602 114.427 369.373 114.75C370.143 115.073 370.342 115.507 368.888 115.793C368.08 115.954 365.085 115.619 365.333 116.128C365.483 116.426 368.379 116.637 368.379 116.637C368.379 116.637 365.259 116.625 365.147 116.811C364.936 117.183 368.068 117.32 368.205 117.308C368.205 117.308 365.52 117.456 365.495 117.705C365.47 118.003 368.18 117.879 368.155 117.928C368.155 117.928 366.017 118.077 366.042 118.251C366.067 118.487 367.944 118.524 368.316 118.475C368.677 118.437 372.356 118.015 372.977 117.891C373.599 117.767 374.63 117.692 374.63 117.692L374.568 115.408Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.367 100.881C381.367 100.881 384.4 112.328 384.139 115.146C383.878 117.964 372.978 118.486 372.978 118.486V115.518C372.978 115.518 378.683 114.252 379.751 112.948C380.311 112.266 376.582 103.563 376.582 103.563C376.582 103.563 373.251 98.1249 376.408 96.7344C379.577 95.3563 380.945 99.2298 381.367 100.881Z",
    fill: "#DBDFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6329 131.896C67.6329 131.896 65.8431 132.789 64.1403 132.951C64.1403 132.951 62.5369 130.592 61.5923 128.829C59.355 124.62 58.6839 122.659 58.8827 121.045C59.2307 118.14 64.9357 106.544 64.9357 106.544L71.2746 108.99L66.4148 117.606C65.9674 118.487 65.3832 119.927 64.7742 121.094C63.9787 122.621 64.9357 126.123 65.4951 127.587C65.4951 127.587 66.5267 130.418 67.6329 131.896Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8087 179.706C47.8087 179.706 47.6223 180.761 48.3432 182.164C49.0641 183.567 52.333 187.142 52.1092 188.607C51.8855 190.072 48.1195 189.898 45.7579 187.316C43.3964 184.734 39.8789 182.052 40.0032 181.431C40.1275 180.811 43.6822 177.583 44.9127 177.16C46.1557 176.726 47.8087 179.706 47.8087 179.706Z",
    fill: "#353A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1125 178.326L47.7825 179.754L44.7871 177.209L46.1667 175.607L49.1125 178.326Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.999 175.61C46.4657 173.959 58.261 161.904 58.261 161.904C64.2767 154.976 66.6258 154.79 66.6258 154.79C66.6258 154.79 68.1422 154.827 70.2054 155.1C70.5037 155.138 71.4732 155.125 71.7715 155.187C75.5997 155.808 75.7116 155.374 74.3071 158.502C72.0077 163.654 48.9142 178.528 48.9142 178.528L44.999 175.61Z",
    fill: "#248C9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8787 181.891C98.8787 181.891 100.768 182.71 102.433 182.946C104.099 183.169 108.114 182.511 109.257 183.604C110.401 184.696 107.94 187.862 104.236 188.334C100.532 188.806 95.7963 189.588 95.3364 189.091C94.8765 188.595 94.4912 184.175 94.8765 182.834C95.2743 181.506 98.8787 181.891 98.8787 181.891Z",
    fill: "#353A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0846 179.93L98.8801 181.891L94.8903 182.847L94.2812 180.749L98.0846 179.93Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0936 155.187C92.0936 155.187 90.4654 148.992 94.2811 163.579C94.2811 163.579 98.3082 179.148 98.7432 180.029C98.8427 180.24 93.697 181.184 93.61 181.147C92.7151 180.787 84.6982 160.848 82.7096 157.161C80.957 153.92 92.0936 155.187 92.0936 155.187Z",
    fill: "#248C9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0934 155.185L84.0766 159.791C84.0766 159.791 80.9195 155.918 78.8314 154.341C78.6201 154.18 78.3964 154.018 78.1851 153.845C77.8744 153.609 77.5637 153.373 77.2654 153.137C77.0416 152.963 76.8179 152.789 76.5942 152.603C75.0654 151.386 73.636 150.157 72.853 149.251C70.5784 146.631 75.5501 130.082 81.8269 137.469C81.8269 137.457 90.2414 145.353 92.0934 155.185Z",
    fill: "#248C9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3314 135.495C81.3314 135.495 77.3789 153.621 73.4886 159.779C73.4886 159.779 66.8762 157.557 63.8435 156.365C63.8435 156.365 63.5452 143.267 63.8435 139.84C64.117 136.662 81.3314 135.495 81.3314 135.495Z",
    fill: "#248C9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.047 141.852C63.047 141.852 64.7125 125.563 63.3329 117.99C62.4131 112.95 63.7431 104.78 66.7634 100.361C67.1238 99.8268 67.5091 99.3426 67.9068 98.9453C67.9068 98.9453 74.0096 100.559 74.6186 100.981C74.7056 101.043 75.3644 101.627 76.1971 102.645C77.9372 104.768 80.4976 108.629 80.7462 112.366C80.9326 115.085 81.0818 117.58 81.2434 120.163C81.2931 120.945 81.3428 121.739 81.4049 122.546C81.5417 124.483 81.7033 126.519 81.8897 128.754C82.0016 129.995 82.8343 133.956 83.3936 137.593L63.047 141.852Z",
    fill: "#2AA3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1974 153.846C77.8867 153.61 77.5759 153.374 77.2776 153.138C77.0539 152.964 76.8302 152.791 76.6064 152.604C76.9296 151.586 78.6697 146.931 79.3533 143.604C79.3409 143.604 79.8505 148.781 78.1974 153.846Z",
    fill: "#196370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4162 122.559C81.4162 122.559 77.8614 127.948 77.2275 114.639L81.2546 120.176C81.3043 120.958 81.3665 121.753 81.4162 122.559Z",
    fill: "#1D6F7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9064 98.9456C67.9064 98.9456 68.5403 95.4197 67.807 93.3712C67.0612 91.3227 73.8848 96.8226 73.8848 96.8226C73.8848 96.8226 73.8848 97.1082 73.8973 97.5303C73.9097 97.8655 73.9221 98.2876 73.9594 98.7221C74.0216 99.5663 74.1334 100.473 74.3447 100.994C74.7797 102.161 67.9064 98.9456 67.9064 98.9456Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7623 86.6059C77.7623 86.6059 79.2041 89.3124 78.4708 89.7221C77.8742 90.0697 79.1544 92.7141 79.3159 93.1486C79.4775 93.5831 78.2346 93.8811 77.9612 94.1666C77.7001 94.4398 76.8798 97.8539 75.8606 97.9532C74.829 98.0526 70.2053 96.4138 68.9624 95.0978C67.7071 93.7818 66.7127 87.8598 67.5704 85.3644C68.428 82.8689 75.2267 81.8881 77.7623 86.6059Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0476 87.1891C78.0476 87.1891 79.5515 84.2964 76.8668 82.1113C74.1821 79.9387 69.1856 83.688 68.6263 83.8246C68.0669 83.9612 64.7359 85.0288 66.4014 89.97C67.9178 94.4519 68.1167 94.9609 68.1167 94.9609C68.1167 94.9609 69.0364 91.9813 69.6206 91.5592C70.5404 90.9012 72.529 91.075 72.529 91.075C72.529 91.075 71.5968 88.5423 73.0883 88.1947C74.5799 87.8719 76.5437 86.618 78.0476 87.1891Z",
    fill: "#3B3B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9635 89.6342C70.8392 89.2866 70.4166 87.7968 69.1364 88.6658C67.8562 89.5349 69.907 92.3531 70.1307 92.3903C70.3544 92.4276 72.0448 92.5517 70.9635 89.6342Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9462 98.7344C71.8332 98.1633 70.0186 95.8789 70.0186 95.8789C70.5903 96.4376 73.884 97.5425 73.884 97.5425C73.8965 97.8777 73.9089 98.2874 73.9462 98.7344Z",
    fill: "#A77860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5239 117.891L94.081 135.582L82.7207 133.372L85.7161 115.606L97.5239 117.891Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.666 118.761L93.6208 134.466L83.5283 132.504L86.1882 116.725L96.666 118.761Z",
    fill: "#E0CEC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4718 118.536L93.6831 117.432L89.6063 116.649L89.2334 117.717L93.4718 118.536Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1917 130.303C96.1917 130.303 95.6945 130.514 95.4335 130.502C95.4335 130.502 94.9612 130.44 94.6132 130.415C94.5013 130.402 94.4143 130.402 94.3522 130.402C94.0912 130.415 93.5319 130.526 92.9104 130.39C92.2889 130.253 89.7285 128.975 89.7285 128.975L90.0268 127.398L90.1014 125.883C90.1014 125.883 93.8177 124.617 94.4143 124.679C94.4765 124.679 94.5262 124.691 94.5883 124.704C95.0855 124.803 95.4211 125.089 95.6821 125.176C95.7815 125.2 96.6889 125.573 96.7883 125.858C96.9126 126.243 96.838 126.566 96.664 126.79C96.664 126.79 96.8753 127.559 96.6516 128.056C96.6516 128.056 96.8753 128.764 96.4154 129.297C96.4154 129.297 96.5522 130.042 96.1917 130.303Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9629 125.54C90.9629 125.54 90.6148 127.514 89.7324 128.978C89.7324 128.978 86.8861 128.867 84.9098 128.569C80.1992 127.861 78.2229 127.228 77.0297 126.111C74.9043 124.112 68.9756 112.615 68.9756 112.615L74.7179 108.99L78.7574 118.016C79.1924 118.91 80.0003 120.226 80.5845 121.405C81.3426 122.957 84.7234 124.273 86.2398 124.695C86.2273 124.683 89.1233 125.54 90.9629 125.54Z",
    fill: "#EEA886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5772 113.893L71.0519 117.283C71.0519 117.283 69.7592 114.787 69.3739 113.968C68.2926 111.634 66.6022 108.108 68.7152 106.618C73.2767 103.403 75.2405 108.741 76.3591 111.659C76.7071 112.565 77.5772 113.893 77.5772 113.893Z",
    fill: "#2AA3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3309 56.633C33.0236 54.1252 26.896 55.4536 23.0802 59.5009C22.1605 60.4817 21.365 61.6239 20.756 62.9026C18.9164 66.7885 19.1402 71.1214 20.9921 74.6597C22.2723 77.1054 24.3356 79.1788 27.0327 80.4575C27.3061 80.5817 27.5672 80.7058 27.8406 80.8051C29.0711 81.2893 30.3389 81.5749 31.6067 81.6742C36.9139 82.1087 42.1839 79.2657 44.5952 74.1755C47.7273 67.6079 44.9183 59.7492 38.3309 56.633ZM41.6246 72.7726C39.8099 76.5964 35.8699 78.7194 31.8925 78.3966C30.9479 78.3221 29.9909 78.0987 29.0711 77.7386C28.8722 77.6641 28.6609 77.5648 28.4621 77.4779C26.4361 76.5219 24.8949 74.9701 23.9254 73.1326C22.5333 70.4758 22.3593 67.2355 23.7514 64.3179C24.2113 63.362 24.7955 62.5053 25.4915 61.7728C28.3502 58.7436 32.949 57.7379 36.9264 59.6126C41.8483 61.9467 43.9613 67.8314 41.6246 72.7726Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9237 73.1347L21.0029 74.6617C19.1509 71.1234 18.9272 66.7906 20.7667 62.9047C21.3757 61.6259 22.1588 60.4837 23.091 59.5029L25.4898 61.7625C24.7938 62.495 24.2096 63.3516 23.7497 64.3076C22.3576 67.2375 22.5316 70.4778 23.9237 73.1347Z",
    fill: "#2D5BAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.059 77.7398L27.8534 80.8063C27.5799 80.6946 27.3065 80.5828 27.0455 80.4587C24.3483 79.1799 22.2851 77.119 21.0049 74.6608L23.9257 73.1338C24.8828 74.9712 26.4364 76.5231 28.4624 77.4791C28.6613 77.566 28.8601 77.6653 29.059 77.7398Z",
    fill: "#5D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6176 81.6895C30.3498 81.5902 29.0821 81.3046 27.8516 80.8204L29.0572 77.7539C29.977 78.1139 30.934 78.3374 31.8786 78.4119L31.6176 81.6895Z",
    fill: "#5D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6347 90.3679H4V89.8837H28.1375V79.4551H28.6347V90.3679Z",
    fill: "#5D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9637 84.7939H4V87.7239H16.9637V84.7939Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1079_4873",
    x: 0,
    y: 0,
    width: 442,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1079_4873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1079_4873",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1079_4873",
    x1: 309.723,
    y1: 31.5315,
    x2: 323.628,
    y2: 77.3868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1079_4873",
    x1: 336.245,
    y1: 17.7628,
    x2: 359.784,
    y2: 95.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1079_4873",
    x1: 349.72,
    y1: 50.0273,
    x2: 360.373,
    y2: 85.1601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1079_4873",
    x1: 3.99609,
    y1: 108.294,
    x2: 438.084,
    y2: 108.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1079_4873",
    x1: 121.421,
    y1: 91.4257,
    x2: 121.421,
    y2: 62.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1079_4873",
    x1: 128.459,
    y1: 91.4266,
    x2: 128.459,
    y2: 62.9092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1079_4873",
    x1: 135.495,
    y1: 91.426,
    x2: 135.495,
    y2: 62.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1079_4873",
    x1: 142.533,
    y1: 91.4255,
    x2: 142.533,
    y2: 62.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1079_4873",
    x1: 259.658,
    y1: 229.519,
    x2: 263.482,
    y2: 12.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1079_4873",
    x1: 275.166,
    y1: 49.4876,
    x2: 302.103,
    y2: 49.4876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1079_4873",
    x1: 275.166,
    y1: 63.7529,
    x2: 299.893,
    y2: 63.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1079_4873",
    x1: 275.166,
    y1: 56.6194,
    x2: 296.56,
    y2: 56.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1079_4873",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.043 114.684) scale(155.515 155.338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1602,
    stopColor: "#90C2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    stopColor: "#47AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6783F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1079_4873",
    x1: 172.546,
    y1: 154.693,
    x2: 171.463,
    y2: 111.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1079_4873",
    x1: 178.043,
    y1: 154.825,
    x2: 176.96,
    y2: 111.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1079_4873",
    x1: 341.567,
    y1: -6.91879,
    x2: 331.817,
    y2: 29.5945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1079_4873",
    x1: 341.079,
    y1: -7.04875,
    x2: 331.329,
    y2: 29.4638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079_4873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434,
    height: 189,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustoryThumbnail12);
export default __webpack_public_path__ + "static/media/industoryThumbnail12.eaf9730e205986e5c37b0ce8b476822b.svg";
export { ForwardRef as ReactComponent };